export default __webpack_public_path__ + "static/team-shay-f346cca10c98779f94c9e921e982543f.png";